import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles((theme) => ({
  addCertificationsContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 24,
    marginTop: 15
  },
  certificationsNotesContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    width: 430,
    height: 42,
  },
  deleteButton: {
    minWidth: 16,
    height: 16,
  },
  addButton: {
    ...theme.typography.buttons,
    fontWeight: 700,
    color: theme.colors.clearMain,
    minWidth: 162,
    height: 24,
    borderRadius: 5,
    padding: "11px 16px",
    borderWidth: 1,
    borderColor: theme.colors.clearMain,
    border: "solid",
    justifyContent: "space-around",
    "&:disabled": {
      color: theme.colors.grey4,
      borderColor: theme.colors.grey4,
      opacity: 0.3
    }
  },
  addButtonItems: {
    width: "100%",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    gap: 10
  },
  notesBoldText: {
    fontFamily: "Roboto,sans serif",
    fontWeight: 700,
    fontSize: 12,
    color: theme.colors.grey5
  },
  notesText: {
    fontFamily: "Roboto,sans serif",
    fontWeight: 400,
    fontSize: 12,
    color: theme.colors.grey5
  },
  certificationsContainer: {
    display: "flex",
    flexDirection: "column",
    minWidth: 162,
  },
  certificationHiddenContainer: {
    display: "none"
  },
  certificationContainer: {
    display: "flex",
    height: 24,
    padding: "8px 16px",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 4,
    backgroundColor: "#FAFAFA"
  },
  certificationName: {
    fontFamily: "Roboto,sans serif",
    color: theme.colors.grey4,
    fontSize: 10,
    fontWeight: 700,
    overflow: "hidden",
    wordWrap: "break-word",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
  },
  modalDelete: {
    height: 220
  },
  modalCenter: {
    display: "flex",
    justifyContent: "center",
  },
  modalTitleSpace: {
    margin: "24px 0px 8px 0px",
  },
  modalTitleText: {
    fontSize: 18,
    lineHeight: "22px",
    textAlign: "center",
    fontStyle: "normal",
    fontWeight: "bold",
    color: theme.colors.grey7
  },
  header: {
    ...theme.typography.txtBody2,
    color: theme.colors.grey4,
    marginBottom: 20
  },
  servicesContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly"
  },
  serviceItem: {
    margin: 10
  },
  divider: {
    marginTop: 30,
    marginBottom: 24,
    width: 772,
    height: 0,
    border: "1px solid #F6F6F6"
  },
}));